import { render, staticRenderFns } from "./project-consume.vue?vue&type=template&id=90c82c84&scoped=true&"
import script from "./project-consume.vue?vue&type=script&lang=js&"
export * from "./project-consume.vue?vue&type=script&lang=js&"
import style0 from "./project-consume.vue?vue&type=style&index=0&id=90c82c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c82c84",
  null
  
)

export default component.exports